import { Form, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../features/fetch/fetchSlice";
import { setFilterObj } from "../../features/obj/objSlice";
import { getMonthsForQuarter } from "../../utils";

function SetHeader() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();

  const [showType, setShowType] = useState(false);
  const [showQuarter, setShowQuarter] = useState(false);
  const [showMonth, setShowMonth] = useState(false);

  const urlYear = "api/v1/fiscal-years/list";
  const urlType = "api/v1/data-request-types/list";
  const urlMonth = "api/v1/months/list";
  const urlQuarters = "api/v1/quarters/list";

  const { dataYear, dataType, dataMonth, dataQuarter, filterObj } = useSelector(
    (state) => ({
      filterObj: state.obj.filterObj,
      dataYear: state.fetch.data[urlYear] || [],
      dataType: state.fetch.data[urlType] || [],
      dataMonth: state.fetch.data[urlMonth] || [],
      dataQuarter: state.fetch.data[urlQuarters] || [],
    })
  );

  useEffect(() => {
    dispatch(fetchData({ url: urlYear }));
  }, []);

  const handleValuesChange = (changedValues) => {
    let updated = { ...filterObj, ...changedValues };

    if (changedValues?.code) {
      const selectedYearObj = dataYear?.find(
      (item) => item?.fiscalYear === changedValues?.code
    );
      updated = { ...updated, fsType: null, quarter: null, month: null, 
        financialYr: selectedYearObj?.code || null, 
         };
      form.setFieldsValue({ fsType: null, quarter: null, month: null });

      setShowType(true);
      setShowQuarter(false);
      setShowMonth(false);

      dispatch(fetchData({ url: urlType }));
    }

    if (changedValues?.fsType) {
      const selectedType = dataType?.find(
        (t) => t?.name === changedValues?.fsType
      );

      updated = { ...updated, quarter: null, month: null };
      form.setFieldsValue({ quarter: null, month: null });

      if (selectedType?.name === "MONTHLY") {
        setShowQuarter(false);
        setShowMonth(true);
        dispatch(fetchData({ url: urlMonth, qtrId: null }));
      } else if (selectedType?.name === "QUARTERLY") {
        setShowQuarter(true);
        setShowMonth(false);
        dispatch(fetchData({ url: urlQuarters }));
      } else {
        setShowQuarter(false);
        setShowMonth(false);
      }
    }

    if (changedValues?.quarter) {
    const months = getMonthsForQuarter(changedValues?.quarter);
    updated = { ...updated, monthsInQuarter: months };
  }

    dispatch(setFilterObj(updated));
  };

  useEffect(() => {
    form.setFieldsValue({
      ...filterObj,
    });
  }, [filterObj, form]);

  useEffect(() => {
    if (filterObj?.code) setShowType(true);
    if (filterObj?.fsType === "MONTHLY") setShowMonth(true);
    if (filterObj?.fsType === "QUARTERLY") setShowQuarter(true);
  }, [filterObj]);
console.log("dataYear",dataYear)
  return (
    <Form
      layout="vertical"
      ref={formRef}
      form={form}
      name="control-ref"
      className="w-full"
      onValuesChange={handleValuesChange}
    >
      <div className="grid lg:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-[2.25rem]">
        <Form.Item name="code" label="Year">
          <Select
            allowClear
            style={{ width: "100%" }}
            options={dataYear?.map((item) => ({
              value: item?.fiscalYear,
              label: item?.code,
            }))}
            placeholder="Select Year"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.label?.toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>

        {showType && (
          <Form.Item name="fsType" label="Type">
            <Select
              allowClear
              style={{ width: "100%" }}
              options={dataType.map((item) => ({
                value: item?.name,
                label: item?.name,
              }))}
              placeholder="Select Type"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>
        )}

        {showQuarter && (
          <Form.Item name="quarter" label="Quarter">
            <Select
              allowClear
              style={{ width: "100%" }}
              options={dataQuarter.map((item) => ({
                value: item?.id,
                label: item?.name,
              }))}
              placeholder="Select Quarter"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>
        )}

        {showMonth && (
          <Form.Item name="month" label="Month">
            <Select
              allowClear
              style={{ width: "100%" }}
              options={dataMonth.map((item) => ({
                value: item?.code,
                label: item?.name,
              }))}
              placeholder="Select Month"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>
        )}
      </div>
    </Form>
  );
}

export default SetHeader;
